export default "__VITE_ASSET__C4kxgN5x__"